import DialogCalendar from "./DialogCalendar";
import DialogBase from "../libs/DialogBase";
import Api from "../libs/Api";
import Util from "../libs/Util";
import DialogPassenger from "./DialogPassenger";
import ErrorBalloon from "../libs/ErrorBalloon";

export default class PlanSearchMg {
  static EVENT_READY = 'eventReady';
  static EVENT_SUBMIT = 'eventSubmit';

  constructor() {
    this.el = document.createElement('div');

    this.target = document.querySelector('.js-plan_search');

    this.submitData = null;

    this.onInit();
  }

  async onInit(){
    const data = await Api.getMasterTicketData();

    this.errorMsg = new ErrorBalloon();

    this.dialogCal = new DialogCalendar(this.target,data);
    this.dialogCal.el.addEventListener(DialogCalendar.EVENT_UPDATE_SELECT_DISPLAY,()=>{
      this.updateCalDisplay();
    });
    this.dialogCal.el.addEventListener(DialogBase.EVENT_OPEN_BEFORE,()=>{
      this.errorMsg.hide();
    });

    this.updateCalDisplay();

    this.dialogPassenger = new DialogPassenger(this.target);
    this.dialogPassenger.el.addEventListener(DialogPassenger.EVENT_UPDATE_SELECT_DISPLAY,()=>{
      this.updatePassengerDisplay();
    });
    this.dialogPassenger.el.addEventListener(DialogBase.EVENT_OPEN_BEFORE,()=>{
      this.errorMsg.hide();
    });

    this.updatePassengerDisplay();

    document.querySelector('.js-plans_error .-btn_retry button').addEventListener('click',this.onClickSubmit.bind(this));

    this.target.querySelector('.-btn_submit button').addEventListener('click',this.onClickSubmit.bind(this));

    this.el.dispatchEvent(new CustomEvent(PlanSearchMg.EVENT_READY));
  }

  onClickSubmit(){
    const passengers = this.dialogPassenger.getCheckData();

    let isError = false;

    //年齢が非選択かチェック
    let errorRoomNo = 0;
    const chage = passengers.chdage;
    chage.forEach((ages,index)=>{
      ages.forEach(age=>{
        if(age === "-") {
          if(!isError){
            isError = true;
            errorRoomNo = index + 1;
          }
        }
      })
    });
    if(isError){
      this.errorMsg.show(this.target.querySelector('.-passenger'),'部屋'+errorRoomNo+'の'+LtikeCommon.TEXT.ERROR_PASSENGER_YEARS_OLD_UNKNOWN);
    } else {
      this.setSubmitData();
      this.el.dispatchEvent(new CustomEvent(PlanSearchMg.EVENT_SUBMIT));
    }
  }

  updateCalDisplay(){
    this.target.querySelector('.-date [data-type="in"] .-value').innerHTML = this.dialogCal.startDays || '';
    this.target.querySelector('.-date [data-type="out"] .-value').innerHTML = this.dialogCal.endDays || '';
  }

  updatePassengerDisplay(){
    this.target.querySelector('.-passenger .-value').innerHTML = this.dialogPassenger.displayText || '';
  }

  setSubmitData(){
    const checkindate = Util.formatStringToPostString(this.dialogCal.startDays);
    const checkoutdate = Util.formatStringToPostString(this.dialogCal.endDays);
    const passengers = this.dialogPassenger.getData();
    this.submitData = {
      checkindate,
      checkoutdate,
      ...passengers
    };

    return this.submitData;
  }
}
